import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {validate as isUUID} from "uuid";
import PageActions from "../../../base/PageActions";
import ContentBox from "../../../../components/content-box/ContentBox";
import ChooseYourStarterIntro from "./components/ChooseYourStarterIntro";
import ChooseYourStarterGame, {_unknown_pokemon} from "./components/ChooseYourStarterGame";
import ChooseYourStarterState from "../../../../model/pokemon/ChooseYourStarterState";
import _http_service from "../../../../services/HttpService";
import './ChooseYourStarterPage.scss';
import '../../../styles/Common.scss';
import '../../../styles/Form.scss';

const ChooseYourStarterPage = () => {

    const _error_message: string = 'Could not communicate with the server. Please try again!';

    const _initial_game_state = {
        id: "",
        left: {..._unknown_pokemon},
        center: {..._unknown_pokemon},
        right: {..._unknown_pokemon},
        selectedPokemon: [],
        teamSize: 6
    };

    const page: PageActions = new PageActions({
        title: `Choose Your Starter! - Chase the Fox`,
        description: `Build a team of Pokemon by selecting one from a group of three each round!`,
        keywords: ["choose your starter", "pokemon", "pokemon randomizer", "random pokemon generator",
            "pokemon team builder", "pokemon party builder", "Pokémon randomizer", "random Pokémon generator",
            "random pokemon champions team", "pokemon champions team builder", "pokemon champions randomizer"],
        imgSrc: `chase/assets/chase_dragonite.png`,
        url: `choose-your-starter`
    });

    const [params, setParams] = useSearchParams();
    const [game, setGame] = useState<ChooseYourStarterState>({..._initial_game_state});

    const [error, setError] = useState<string | undefined>();

    useEffect(() => {
        let gameId = params.get('id') || undefined;
        if (!gameId || !isUUID(gameId)) {
            setParams({});
            setGame({..._initial_game_state});
        } else {
            _http_service.getChooseYourStarterGameState(gameId)
                .then(response => {
                    setGame(response);
                })
                .catch(() => {
                    setParams({});
                    if (!gameId || !isUUID(gameId)) {
                    } else {
                        setError("Game ID could not be found.");
                    }
                });
        }
    }, [params]);

    const submit = (id: string) => {
        setParams({id: id});
    }

    const showError = (reveal: boolean = true): void => {
        setError(reveal ? _error_message : undefined);
    }

    return page.generateMetaContent(
        <>
            <ContentBox header="Choose Your Starter Pokemon (Beta)">
                {(!game || game.id === '')
                    ? <ChooseYourStarterIntro submit={submit} error={error} showError={showError}/>
                    : <ChooseYourStarterGame gameState={game} setGameState={setGame} error={error} showError={showError} />}
            </ContentBox>
        </>
    );
}

export default ChooseYourStarterPage;